import { useEffect, useId } from 'react';
import { useForm } from 'react-hook-form';
import FormInput from '@enerex/unified-ui-react/form/FormInput';
import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import SearchIcon from '@enerex/unified-ui-react/icons/SearchIcon';
import FilterPills from './FilterPills';

// Draft text is controlled by the caller; only explicit submission applies it.
const TableSearch = ({ value, appliedSearch = '', onChange, onSearch, placeholder = 'Search...',
    label = 'Search', disabled = false, inputDisabled = false, buttonDisabled = false,
    maxLength = undefined, showAction = true, showApplied = true }) => {
    const id = useId();
    const { control, setFocus, setValue } = useForm({ defaultValues: { search: value || '' } });
    useEffect(() => { setValue('search', value || ''); }, [value, setValue]);
    const submissionDisabled = disabled || inputDisabled || buttonDisabled;
    const submit = () => {
        if (submissionDisabled) return;
        onSearch((value || '').trim());
        onChange('');
    };
    return <div className="w-100">
        <FormInput
        type="text"
        name="search"
        id={id}
        control={control}
        containerClass="mb-0 w-100"
        aria-label={label}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled || inputDisabled}
        onChange={event => onChange(event.target.value)}
        onKeyDown={event => {
            if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
                event.preventDefault();
                submit();
            }
        }}
        leftComponent={!showAction ? <span className="input-group-text"><SearchIcon aria-hidden="true" /></span> : undefined}
        rightComponent={showAction ? <LoadingButton type="button" variant="primary"
            aria-label="Search" disabled={disabled || inputDisabled || buttonDisabled} onClick={submit}>
            <SearchIcon aria-hidden="true" className="me-1" />Search
        </LoadingButton> : undefined}
        />
        {showApplied && appliedSearch && <div aria-label="Applied search">
            <FilterPills disabled={submissionDisabled} filters={[{
                label: 'Search', value: appliedSearch,
                onRemove: () => { onSearch(''); setFocus('search'); },
            }]} />
        </div>}
    </div>;
};

export default TableSearch;
